import React from 'react';
import { CreditCardIcon, MapPinIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const reasons = [{
  icon: CreditCardIcon,
  title: 'Pagas en la moneda de tu país',
  text: 'El precio se muestra en dólares, pero el sistema convierte el monto y te cobra en tu moneda local al momento del pago.'
}, {
  icon: MapPinIcon,
  title: 'Pensado para México',
  text: 'Bocadillos, precios de referencia y trámites de México. Si estás en otro país, aplicas las recetas, los menús y el costeo con tus propios precios.'
}];
export function WhyGlobal() {
  return <section className="bg-cream py-16 sm:py-20" aria-labelledby="moneda-title" data-id="element-245" data-mp="3bih2p626v6gg">
      <div className="mx-auto max-w-5xl px-6" data-id="element-246" data-mp="3gcbukwry6rqm">
        <Reveal className="text-center" data-id="element-247" data-mp="3lb6bft6cu683">
          <h2 id="moneda-title" className="font-display text-3xl leading-tight text-ink sm:text-4xl" data-id="element-248" data-mp="3la3p7yjz8ryi">
            Compras desde donde estés
          </h2>
        </Reveal>

        <ul className="mt-10 grid gap-6 md:grid-cols-2" data-id="element-249" data-mp="3uccx0gnv2787">
          {reasons.map((reason, index) => <li key={reason.title} className="flex" data-id="element-250" data-mp="2d3pxi0um3nd9" data-mpi={index}>
              <Reveal delay={index * 0.04} className="flex h-full w-full gap-4 rounded-2xl bg-sand p-7 ring-1 ring-inset ring-cream-line" data-id="element-251" data-mp="2d1d66x2ys0nj">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-mint-700 text-white" aria-hidden="true" data-id="element-252" data-mp="234qm4aigpdmk">
                  <reason.icon className="h-5 w-5" data-id="element-253" data-mp="1y806foakkk1o" />
                </span>
                <div data-id="element-254" data-mp="2vsw7mzhcb6ng">
                  <h3 className="font-display text-xl text-ink" data-id="element-255" data-mp="2vt5z6ri19lv9">{reason.title}</h3>
                  <p className="mt-2 text-[15px] leading-relaxed text-ink-soft" data-id="element-256" data-mp="2qw5qe8tsu50g">{reason.text}</p>
                </div>
              </Reveal>
            </li>)}
        </ul>
      </div>
    </section>;
}